import { Team } from "msd-capacity-planning-model";
export const FETCH_TEAMS = "teams/fetch";
export const LOAD_TEAMS = "teams/load";
export const REMOVE_TEAM = "teams/remove";
export const PERSIST_TEAM = "teams/persist";
export const SET_TEAMS_DATE_FILTER = "teams/dateFilter/set";

export interface TeamsState {
  items: { [id: string]: Team };
  synching: boolean;
  dateFilter?: string;
}

export interface FetchTeamsAction {
  type: typeof FETCH_TEAMS;
}

export interface LoadTeamsAction {
  type: typeof LOAD_TEAMS;
  items: Team[];
  dateFilter?: string;
}

export interface RemoveTeamAction {
  type: typeof REMOVE_TEAM;
  id: string;
}

export interface PersistTeamAction {
  type: typeof PERSIST_TEAM;
  item: Team;
}

export interface SetTeamsDateFilterAction {
  type: typeof SET_TEAMS_DATE_FILTER;
  dateFilter: string;
}

export type TeamAction =
  | FetchTeamsAction
  | LoadTeamsAction
  | RemoveTeamAction
  | PersistTeamAction
  | SetTeamsDateFilterAction;
